// src/components/copilot/blocks/ClarificationBlock.js
export default function ClarificationBlock({ block, onClarify }) {
  return (
    <div className="rounded-xl border border-border bg-card p-4">
      <p className="text-sm text-foreground">{block.question}</p>
      <div className="mt-3 flex flex-wrap gap-2">
        {(block.options || []).map((opt) => (
          <button key={opt} onClick={() => onClarify && onClarify(opt)}
            className="rounded-lg bg-primary px-3 py-1 text-sm font-medium text-primary-foreground hover:bg-primary/90">
            {opt}
          </button>
        ))}
      </div>
    </div>
  );
}
